<template>
  <div class="record-con">
    <CommonHeader />
    <div class="layout">
      <div class="re-tit">做题记录</div>
      <div class="re-main clearfix">
        <ul class="subTit">
          <li :class="{'on':item.isChoose===1}" v-for="(item,index) in majorType" :key="index" @click="getRecordsApi(item.categoryID)">{{ item.categoryName }}</li>
        </ul>
        <div class="nullBox" v-if="recordsData && recordsData.length===0">
          <div class="nullBox-pic"><img src="//member.med66.com/medqz/resources/images/2020mokaoxitong/null_02.jpg"></div>
          <div class="nullBox-txt">您还没有答题，先答题再来查看做题记录吧<a href="javascript:void(0)" class="btn" @click="backToExam">去答题</a></div>
        </div>
        <div class="conBox clearfix" v-else>
          <div class="listBox clearfix">
            <div class="roomBox" v-for="(item,index) in recordsData" :key="index">
              <div class="roomBox-tit on">
                <div class="rtTxt">{{ item.showName }}</div>
                <div class="rtJian"></div>
              </div>
              <div class="roomBox-con">
                <template v-if="item.paperViews && item.paperViews.length>0">
                  <div class="unit" v-for="(part,idx1) in item.paperViews" :key="idx1" >
                    <div class="uTit">
                      <div class="uTit-ltxt fl">{{ part.paperViewName }}</div>
                    </div>
                    <div class="uList" v-for="(obj,idx2) in part.records" :key="idx2">
                      <div class="uList-num fl">{{ obj.lastScore }}分</div>
                      <div class="uList-time fl">{{ obj.createTime }}</div>
                      <a :href="obj.analysisUrl" class="uList-btn fr">进入成绩页面</a>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
<!--          <div class="fyBox"><span class="active">1</span></div>-->
        </div>
      </div>
    </div>
    <CommonFooter />
  </div>
</template>

<script>
import { CommonHeader,CommonFooter } from '@components/common'
import { getCategoryMajors,getRecords } from '@/api'
import { getCookie } from "@/utils";

export default {
  name: "index",
  components:{
    CommonHeader,
    CommonFooter
  },
  data(){
    return{
      majorType:[],
      hasNoData:false,
      recordsData:[]
    }
  },
  mounted() {
    const { index,urlName } = this.$route.query
    this.getCategoryMajorsApi(index,urlName)
    this.getRecordsApi(1)
    $(function (){
      $(document).on('mouseover mouseout','.uList',function (event){
        if(event.type=='mouseover'){
          $(this).addClass("on");
        }else if(event.type == "mouseout"){
          $(this).removeClass("on");
        }
      })
      //点击考场展开收起
      $("body").on("click", ".listBox .roomBox-tit", function () {
        var _this = $(this);
        if (_this.hasClass("on")) {
          _this.removeClass("on");
          _this.parents(".roomBox").find(".roomBox-con").slideUp();
        } else {
          _this.addClass("on");
          _this.parents(".roomBox").find(".roomBox-con").slideDown();
        }
      });
    })
  },
  methods:{
    //获取类别0
    getCategoryMajorsApi(index,urlName){
      let params = {
        index:index,
        urlName:urlName
      }
      getCategoryMajors(params).then(res => {
        if(res && res.length>0){
          this.majorType = res
        }
      })
    },
    //获取当前类别下记录
    getRecordsApi(index){
      this.recordsData = []
      this.majorType.forEach(val =>{
        if(val.categoryID===index){
          val.isChoose = 1
        }else{
          val.isChoose = 0
        }
      })

      let params = {
        userID:getCookie('cdeluid'),
        index:index
      }
      getRecords(params).then(res => {
        this.recordsData = res
      })
    },
    backToExam(){
      this.$router.push({
        path:'/entry'
      })
    }
  }
}
</script>
<style scoped lang="scss">
.record-con{
  background: url(https://member.med66.com/medqz/resources/images/2020mokaoxitong/ex_bg_02.jpg) no-repeat center -70px #f7f7f7;
  .re-tit {
    height: 84px;
    line-height: 84px;
    font-size: 24px;
    font-weight: 700;
  }
  .re-main {
    padding: 0 40px 40px;
    background: #fff;
    -webkit-box-shadow: 0 5px 6px rgb(239 239 239);
    -moz-box-shadow: 0 5px 6px rgba(239, 239, 239, 1);
    box-shadow: 0 5px 6px rgb(239 239 239);
    margin-bottom: 40px;
    .subTit {
      height: 80px;
      border-bottom: 2px solid #e8e8e8;
      li {
        float: left;
        height: 80px;
        text-align: center;
        font-size: 20px;
        line-height: 80px;
        color: #333;
        cursor: pointer;
        margin-right: 58px;
        &.on {
          border-bottom: 2px solid #76cc6e;
          color: #4ab83e;
          font-weight: 700;
        }
      }
    }
    .nullBox {
      padding: 50px 0 100px;
      .nullBox-pic {
        display: block;
        width: 329px;
        height: 249px;
        margin: 0 auto;
      }
      .nullBox-txt {
        text-align: center;
        line-height: 66px;
        font-size: 16px;
        .btn {
          display: inline-block;
          padding: 0 30px;
          height: 34px;
          line-height: 34px;
          font-size: 16px;
          color: #4eb942;
          border: 1px solid #4eb942;
          border-radius: 18px;
          margin-left: 10px;
        }
      }
    }
    .conBox {
      padding: 40px 0 0;
      .listBox {
        margin-bottom: 30px;
        .roomBox {
          margin-bottom: 10px;
          .roomBox-tit {
            position: relative;
            z-index: 1;
            height: 58px;
            background: #f7f7f7;
            cursor: pointer;
            .rtTxt {
              float: left;
              line-height: 58px;
              font-size: 18px;
              font-weight: 700;
              margin-left: 20px;
            }
            .rtJian {
              position: absolute;
              top: 24px;
              right: 20px;
              width: 20px;
              height: 11px;
              background: url(//member.med66.com/medqz/resources/images/2020mokaoxitong/as_an.png) no-repeat 0 -550px;
            }
            &.on .rtJian {
              background: url(//member.med66.com/medqz/resources/images/2020mokaoxitong/as_an.png) no-repeat 0 -600px;
            }
          }
          .roomBox-con {
            border: 1px solid #f7f7f7;
            padding: 0 20px;
            .unit {
              margin-bottom: 12px;
              .uTit {
                height: 50px;
                border-bottom: 1px solid #ececec;
                clear: both;
                .uTit-ltxt {
                  display: block;
                  line-height: 50px;
                  font-size: 16px;
                }
              }
              .uList {
                height: 50px;
                border-bottom: 1px solid #ececec;
                clear: both;
                .uList-num {
                  width: 82px;
                  line-height: 50px;
                  font-size: 16px;
                  color: #ff8c25;
                  font-weight: 700;
                  margin-left: 18px;
                }
                .uList-time {
                  line-height: 50px;
                  font-size: 16px;
                  color: #999;
                }
                .uList-btn {
                  display: none;
                  width: 140px;
                  height: 32px;
                  line-height: 32px;
                  text-align: center;
                  font-size: 16px;
                  color: #fff;
                  margin: 9px 20px 0 0;
                  border-radius: 16px;
                  -webkit-box-shadow: 0 3px 6px rgb(74 184 62 / 30%);
                  -moz-box-shadow: 0 3px 6px rgba(74, 184, 62, 0.3);
                  box-shadow: 0 3px 6px rgb(74 184 62 / 30%);
                  background: #28cc82;
                  background: -webkit-linear-gradient(left, #63d560, #07c799);
                  background: -o-linear-gradient(left, #63d560, #07c799);
                  background: -moz-linear-gradient(left, #63d560, #07c799);
                  background: linear-gradient(to right, #63d560, #07c799);
                }
                &.on{
                  background: #f7f7f7;
                  .uList-btn{ display: block;}
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
